import { apiFetch } from './api';

export const createTravel = (data, token) =>
  apiFetch('/travels', { method: 'POST', body: JSON.stringify(data) }, token);

export const getMyTravels = (token) =>
  apiFetch('/travels/mis-viajes', {}, token);

export const completarViaje = (travelId, token) =>
  apiFetch(`/travels/${travelId}/completar`, { method: 'PUT' }, token);